export class Postulante {
    email: string = "";
    apellido1: string = "";
    apellido2: string = "";
    nombres:string = "";
    password:string = "";
    codigoCurso: number = 0;
}
